// extracted by mini-css-extract-plugin
module.exports = {"root":"index_root__1QaKM","header":"index_header__2ZOoW","subheader":"index_subheader__2-mwu","testItem":"index_testItem__ioa5R"};